// src/api/workerClient.js — v8.9 FINAL
//
// ИЗМЕНЕНИЯ:
// 1. AbortController — timeout 10s (задание из аудита)
// 2. Детальный error logging для отладки
// 3. BASE_URL экспортируется для useIngestion.js

export const BASE_URL = import.meta.env.VITE_WORKER_URL ?? "https://app.viraj.marketing";

export async function workerClient(path) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 10_000);

  try {
    const res = await fetch(`${BASE_URL}${path}`, {
      signal: controller.signal,
    });

    clearTimeout(timer);

    if (!res.ok) {
      throw new Error(`HTTP ${res.status}: ${path}`);
    }

    return res.json();
  } catch (err) {
    clearTimeout(timer);
    if (err.name === "AbortError") {
      throw new Error(`Timeout (10s): ${path}`);
    }
    throw err;
  }
}

// ─────────────────────────────────────────────────────────────
// LEGACY EXPORTS — используются в financeMapper.js
// Новый код использует workerClient() напрямую
// ─────────────────────────────────────────────────────────────
import { mapFinanceData } from "./financeMapper";

export async function fetchOwnerDashboard() {
  const data = await workerClient("/api/finance");
  return {
    today: {
      spend:   data.spend   ?? 0,
      revenue: data.revenue ?? 0,
      roi:     data.roi     ?? 0,
      epc:     0,
    },
  };
}

export function fetchDashboardSummary() {
  return workerClient("/api/finance/trends");
}

export async function fetchSystemLogs() {
  const res = await workerClient("/api/logs");
  return Array.isArray(res.logs) ? res.logs : [];
}

export async function fetchAlerts() {
  const res = await workerClient("/api/alerts");
  return Array.isArray(res.alerts)
    ? res.alerts.map((a, idx) => ({
        id:        a.id ?? idx,
        type:      a.level?.toLowerCase() ?? "info",
        title:     a.message ?? "Alert",
        details:   a.message ?? "No details",
        timestamp: a.timestamp
          ? new Date(a.timestamp * 1000).toISOString()
          : new Date().toISOString(),
      }))
    : [];
}

export async function fetchFinance() {
  const summary = await workerClient("/api/finance");
  const trends  = await workerClient("/api/finance/trends");
  return mapFinanceData({ summary, trends });
}
